import React, {useEffect, useState} from 'react';
import axios from 'axios';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import Pagination from '../components/pagination';
import EmptyList from '../components/empty-list';
import Error from '../components/error';
import Header from '../components/header';
import LoadingList from '../components/loading-list';

const withPagination = (Component, opts) => {
  const { queryKey, api, pageNumberLimit, header, loading } = opts;

  return (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const initialPage = Number(searchParams.get('halaman')) || 1;
    const [data, setData] = useState(null);
    const [currentPage, setCurrentPage] = useState(initialPage);
    const [isFetching, setIsFetch] = useState(true);
    const [isError, setIsError] = useState(false);
    const [maxPageLimit, setMaxPageLimit] = useState(pageNumberLimit);
    const [minPageLimit, setMinPageLimit] = useState(0);
    const [searchText, setSearchText] = useState('');

    const onChangeCurrentPageHandler = (page) => {
      setCurrentPage(page);
      setSearchParams({
        halaman: page
      });
    };

    useEffect(() => {
      onChangeCurrentPageHandler(1)
    }, [searchText]);

    const fetchData = async () => {
      try {
        setIsFetch(true);
        setIsError(false);

        const response = await axios.post(
          api,
          {
            name: searchText
          },
          {
            params: {
              page: currentPage
            }
          }
        );

        if (!response?.data?.success) {
          throw new Error('Terjadi kesalahan di server!');
        }

        setData(response?.data);
      } catch (e) {
        setIsError(true);
      } finally {
        setIsFetch(false);
      }
    };

    const { refetch } = useQuery([queryKey, currentPage, searchText], fetchData);

    const renderContent = () => {
      if (isError) {
        return (
          <div className="py-14">
            <Error refetch={refetch} />
          </div>
        );
      }

      return (
        <>
          {!!data?.data?.length ? (
            <>
              <Component
                {...props}
                data={data?.data}
                onSearch={setSearchText}
                searchText={searchText}
              />
              <div className="px-10 pb-14">
                <Pagination
                  onChangeMaxPageLimit={setMaxPageLimit}
                  onChangeMinPageLimit={setMinPageLimit}
                  maxPageLimit={maxPageLimit}
                  minPageLimit={minPageLimit}
                  pageNumberLimit={data?.page?.pageSize || pageNumberLimit}
                  onChangeCurrentPage={onChangeCurrentPageHandler}
                  currentPage={currentPage}
                  totalPage={data?.pages?.pageCount}
                />
              </div>
            </>
          ) : (
            <EmptyList />
          )}
        </>
      );
    };

    return (
      <div className="w-full">
        <Header
          title={header?.title}
          subtitle={header?.subtitle}
          buttonConfigs={{
            disabled: isError,
            ...header?.button
          }}
          onSearch={setSearchText}
          searchText={searchText}
        />
        {isFetching ? <LoadingList loadingConfigs={loading} /> : renderContent()}
      </div>
    );
  };
};

export default withPagination;
